import React, { ChangeEvent } from 'react';
import DialogComponent, { DialogProps } from '../../widgets/dialog/DialogComponent';
import groupService from '../../../services/group-service';

export interface FetchedGroup {
  _id?: string;
  parent?: string;
  name?: string;
  description?: string;
}

export interface Props extends DialogProps {
  groupId: string;
}

export interface State {
  group: FetchedGroup;
  submiting: boolean;
  errors: {
    name: any;
  }
}

export default class EditGroupDialog extends DialogComponent<Props, State> {

  private nameInput: HTMLElement = null;

  state = {
    group: {
      _id: '',
      name: 'در حال بارگذاری',
      parent: 'null',
      description: 'در حال بارگذاری'
    },
    submiting: false,
    errors: {
      name: null
    }
  }

  render() {
    const errors = this.state.errors;
    const nameClass = 'dialog-input lg-input' + (errors.name ? ' input-error' : '');
    return (
      <React.Fragment>
        <div className="row">
          <div className="form-group col-6">
            <input
              type="text"
              ref={input => this.nameInput = input}
              value={this.state.group.name}
              className={nameClass}
              onChange={this.onNameChanged}
              placeholder="نام گروه" />
          </div>
          <div className="form-group col-12">
            <textarea
              placeholder="توضیحات (اختیاری)"
              className="dialog-input lg-input no-resize"
              onChange={this.onDescriptionChange}
              value={this.state.group.description}></textarea>
          </div>
        </div>
        <div className="d-flex justift-content-end mt-2">
          <button
            onClick={this.onSubmitClick}
            style={{ width: '200px' }}
            className="btn btn-app mx-auto"
            disabled={this.state.submiting}>ویرایش گروه</button>
        </div>
      </React.Fragment>
    );
  }

  onNameChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const group = this.state.group;
    this.setState({
      group: {
        ...group,
        ...{ name: event.target.value }
      }
    });
  }

  onDescriptionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const group = this.state.group;
    this.setState({
      group: {
        ...group,
        ...{ description: event.target.value }
      }
    });
  }

  onSubmitClick = async () => {
    const { group } = this.state;
    if (group.name.trim() === '') {
      return this.setState({ errors: { name: true } });
    }
    this.setState({ submiting: true });
    const result = await groupService.update(group._id, group);
    this.resolve(result);
    this.close();
  }

  componentDidMount = async () => {
    this.nameInput.focus();
    if (!this.props.groupId) return;
    const group = await groupService.findById(this.props.groupId);
    this.setState({ group });
  }
}
